export const GET_BUSINESS_LOCATIONS = 'GET_BUSINESS_LOCATIONS';
export const SET_BUSINESS_LOCATIONS = 'SET_BUSINESS_LOCATIONS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_BUSINESS_LOCATION = 'SET_BUSINESS_LOCATION';
export const ADD_BUSINESS_LOCATION = 'ADD_BUSINESS_LOCATION';
export const EMPTY_BUSINESS_LOCATION = 'EMPTY_BUSINESS_LOCATION';
export const DELETE_BUSINESS_LOCATION = 'DELETE_BUSINESS_LOCATION';
export const EDIT_BUSINESS_LOCATION = 'EDIT_BUSINESS_LOCATION';
export const UPDATE_BUSINESS_LOCATION = 'UPDATE_BUSINESS_LOCATION';
export const SET_BUSINESS_LOCATION_FILTER = 'SET_BUSINESS_LOCATION_FILTER';